import React, { useState, useEffect } from 'react'
import api from '../../api';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MapPin, Building, Home, Filter } from 'lucide-react';

function Section_3() {
    const userID = sessionStorage.getItem("RoleCode");
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false);
    const [taluk, setTaluk] = useState("");
    const [village, setVillage] = useState("");
    const [villages, setVillages] = useState([]);
    const [filteredData, setFilteredData] = useState(null);

    const district = "Chitradurga District"; 
    const districtData = {
        "Chitradurga District": {
            "Chitradurga": [
                "Jodichikkenahalli",
                "Kyadigere",
                "Hale Dyamavvana Halli",
                "J J Hatti",
                "Kasavanahalli",
                "Ennegere",
                "Gonur",
                "Venkateshwara Badavane",
                "Gandhi Nagara",
                "Kasavarahatti"
            ],
            "Hiriyur": [
                "Hosakere",
                "Halagaladdi",
                "Khandenahalli Palya",
                "Benakanahalli",
                "P D Kote",
                "Adivala Farm",
                "T G Colony",
                "Bovi Colony",
                "Adivala",
                "Gollarahatti"
            ],
            "Holalkere": [
                "Kolalu",
                "Echaghatta",
                "T-Nulenuru",
                "Kereyagalahalli",
                "Halenahalli",
                "Hulikere",
                "Kudineer Katte",
                "Talya",
                "Tekalarvatti",
                "Holalkere_Gollarahatti"
            ]
        }
    };

    useEffect(() => {
        if (taluk) {
            setVillages(districtData[district][taluk] || []);
            setVillage("");
        } else {
            setVillages([]);
            setVillage("");
        }
    }, [taluk]);

    useEffect(() => {
        if (!data) return;

        const filterDataByLocation = (items, taluk, village) => {
            if (!Array.isArray(items)) return items;
            
            return items.filter(item => {
                const itemTaluk = item.taluk_name || item.fld_taluk_name;
                const itemVillage = item.village_name || item.fld_village_name;
                
                const talukMatch = !taluk || itemTaluk === taluk;
                const villageMatch = !village || itemVillage === village;
                
                return talukMatch && villageMatch;
            });
        };

        const filtered = JSON.parse(JSON.stringify(data));
        
        const filterNestedData = (obj) => {
            if (Array.isArray(obj)) {
                return filterDataByLocation(obj, taluk, village);
            } else if (obj && typeof obj === 'object') {
                const result = {};
                for (const key in obj) {
                    result[key] = filterNestedData(obj[key]);
                }
                return result;
            }
            return obj;
        };

        setFilteredData(filterNestedData(filtered));
    }, [data, taluk, village]);

    const rawData = async () => {
        setLoading(true)
        try {
            const requestData = {
                login_user_id: userID,
                synceddatetime: "2023-01-24 11:57:34",
                FormCode: "314",
                ApiKey: "kavin",
                AppTypeNo: "3",
                AppVersion: "1.0.0"
            };
            const url = 'section_3_dashboard'
            const result = await api.get_Dashboard_Section(url, requestData);
            setData(result.responsemessage.household_dashboard_3)
        } catch (error) {
            console.error("Error fetching requested data:", error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        rawData();
    }, []);

    const DashboardCards = () => {
        if (!filteredData) return null;

        const extractDataFields = (items) => {
            if (!items || items.length === 0) return null;
            
            const firstItem = items[0];
            
            const countField = Object.keys(firstItem).find(key => {
                const lowerKey = key.toLowerCase();
                return (
                    lowerKey.endsWith('_count') || 
                    lowerKey === 'count' ||
                    lowerKey.includes('diet_count') ||
                    lowerKey.includes('vegetable_intake_count') ||
                    lowerKey.includes('intake_count') ||
                    lowerKey.includes('consumption_count') ||
                    lowerKey.includes('activity_count') ||
                    lowerKey.includes('use_count') ||
                    lowerKey.includes('duration_count') ||
                    lowerKey.includes('quality_count') ||
                    (lowerKey.includes('count') && !lowerKey.includes('percentage'))
                );
            });
            
            const percentageField = Object.keys(firstItem).find(key => 
                key.toLowerCase().endsWith('_percentage') || 
                (key.toLowerCase().includes('percentage') && 
                 !key.toLowerCase().includes('grand_total') &&
                 !key.toLowerCase().includes('taluk_percentage') &&
                 !key.toLowerCase().includes('village_percentage'))
            );

            const nameField = Object.keys(firstItem).find(key => {
                const lowerKey = key.toLowerCase();
                const excludedFields = ['taluk', 'village', 'id', 'total', 'percentage', 'count'];
                
                const isExcluded = excludedFields.some(excluded => 
                    lowerKey.includes(excluded)
                );
                
                if (isExcluded) return false;
                
                return (
                    lowerKey.endsWith('_status') ||
                    lowerKey.endsWith('_type') ||
                    lowerKey.includes('diet_status') ||
                    lowerKey.includes('vegetable_intake_status') ||
                    lowerKey.includes('frequency') ||
                    lowerKey.includes('activity') ||
                    lowerKey.includes('quality') ||
                    lowerKey.includes('duration') ||
                    lowerKey.includes('use') ||
                    (lowerKey.length > 5 && !isExcluded && 
                     !lowerKey.includes('taluk') && 
                     !lowerKey.includes('village'))
                );
            });

            return { countField, percentageField, nameField };
        };

        const aggregateDataByCategory = (items, nameField, countField) => {
            if (!items || !nameField || !countField) return [];
            
            const aggregated = {};
            
            items.forEach(item => {
                const categoryName = item[nameField];
                const countValue = parseFloat(item[countField]) || 0;
                
                if (categoryName) {
                    if (!aggregated[categoryName]) {
                        aggregated[categoryName] = {
                            name: categoryName,
                            count: 0
                        };
                    }
                    aggregated[categoryName].count += countValue;
                }
            });
            
            const result = Object.values(aggregated);
            const totalCount = result.reduce((sum, item) => sum + item.count, 0);
            
            result.forEach(item => {
                item.percentage = totalCount > 0 ? (item.count / totalCount) * 100 : 0;
            });
            
            return result;
        };

        const cardColors = {
            "Behavior And Cultural Determinant": "#2563eb",
            "Nutrition": "#ec4899", 
            "Physical Activity": "#f59e0b",
            "Substance Use": "#15803d",
            "Sleep": "#a855f7",
            "Health Checkups": "#dc2626",
            "Mental Health": "#fb923c",
            "Safety": "#e11d48"
        };

        const renderCardBlock = (category, subCategory, items, label) => {
            if (!Array.isArray(items) || items.length === 0) return null;

            const { countField, percentageField, nameField } = extractDataFields(items);
            
            if (!countField || !nameField) {
                return null;
            }

            const aggregatedItems = aggregateDataByCategory(items, nameField, countField);
            
            if (aggregatedItems.length === 0) {
                return null;
            }

            const totalCount = aggregatedItems.reduce((sum, item) => sum + item.count, 0);
            const cardColor = cardColors[category] || "#4ca8db";

            return (
                <div className="bar text-600" key={`${category}-${subCategory}`}>
                    <div>
                        <div className="flex justify-content-between align-items-center">
                            <p className="w-9 font-semibold">{label}</p>
                            <p className="font-medium">Total - {totalCount}</p>
                        </div>

                        <div className="grid flex align-items-center mb-3 headingCard f12 font-semibold">
                            <div className="col-5">Category</div>
                            <div className="col-2 text-center">Count</div>
                            <div className="col-5">Percentage</div>
                        </div>

                        {aggregatedItems.map((item, idx) => (
                            <div className="grid flex align-items-center mt-2 f12" key={idx}>
                                <div className="col-5">
                                    <span className="font-medium">{item.name}</span>
                                </div>
                                <div className="col-2 text-center">
                                    <span>{item.count}</span>
                                </div>
                                <div className="col-5">
                                    <div className="flex align-items-center gap-2">
                                        <div style={{
                                            height: "8px",
                                            backgroundColor: "#e0e0e0",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            position: "relative",
                                            flex: 1
                                        }}>
                                            <div style={{
                                                height: "100%",
                                                backgroundColor: cardColor,
                                                width: `${parseFloat(item.percentage) || 0}%`,
                                                borderRadius: "10px",
                                                transition: "width 0.3s ease"
                                            }} />
                                        </div>
                                        <span style={{ minWidth: '45px', fontSize: '11px' }}>
                                            {parseFloat(item.percentage || 0).toFixed(1)}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        };

        const renderAllCategories = () => {
            if (!filteredData) return null;

            return Object.keys(filteredData).map(mainCategory => {
                const mainCategoryData = filteredData[mainCategory];
                if (typeof mainCategoryData !== 'object') return null;

                return Object.keys(mainCategoryData).map(subCategory => {
                    const items = mainCategoryData[subCategory];
                    if (!Array.isArray(items) || items.length === 0) return null;

                    const label = subCategory
                        .replace(/_/g, ' ')
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/\b\w/g, l => l.toUpperCase())
                        .trim();

                    return (
                        <div key={`${mainCategory}-${subCategory}`} className="mb-4">
                            <div className="font-semibold text-lg mb-2 text-gray-700 border-b pb-1">
                                {mainCategory} - {label}
                            </div>
                            <div className="first-cards">
                                <div className="first-sub">
                                    {renderCardBlock(mainCategory, subCategory, items, label)}
                                </div>
                            </div>
                        </div>
                    );
                });
            });
        };

        return (
            <div className='render-container'>
                {renderAllCategories()}
            </div>
        );
    };

    const activeFiltersCount = [taluk, village].filter(Boolean).length;

    return (
        <div style={{ backgroundColor: '#eff6ff', minHeight: '100vh' }}>
            {loading && (
                <div className="backdrop">
                    <ProgressSpinner className='progressBar' />
                </div>
            )}

            <div style={{
                background: 'linear-gradient(to bottom right, #ffffff, #f9fafb)',
                borderRadius: '0.75rem',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                marginBottom: '1rem'
            }}>
                {/* <div style={{
                    background: 'linear-gradient(to right, #3b82f6, #2563eb)',
                    padding: '1rem 1.5rem'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                backdropFilter: 'blur(8px)',
                                borderRadius: '0.5rem',
                                padding: '0.5rem'
                            }}>
                                <Filter style={{ width: '1.25rem', height: '1.25rem', color: 'white' }} />
                            </div>
                            <div>
                                <h2 style={{ color: 'white', fontWeight: 600, fontSize: '1.125rem', margin: 0 }}>Location Filters</h2>
                                <p style={{ color: '#dbeafe', fontSize: '0.75rem', margin: 0 }}>Select your location hierarchy</p>
                            </div>
                        </div>
                        {activeFiltersCount > 0 && (
                            <div style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                backdropFilter: 'blur(8px)',
                                padding: '0.375rem 0.75rem',
                                borderRadius: '9999px'
                            }}>
                                <span style={{ color: 'white', fontSize: '0.875rem', fontWeight: 500 }}>
                                    {activeFiltersCount} {activeFiltersCount === 1 ? 'filter' : 'filters'} active
                                </span>
                            </div>
                        )}
                    </div>
                </div> */}

                <div style={{ padding: '1.5rem' }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '1.5rem'
                    }}>
                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#dbeafe',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <MapPin style={{ width: '1rem', height: '1rem', color: '#2563eb' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>District</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={district}
                                    disabled
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        backgroundColor: '#f9fafb',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        color: '#4b5563',
                                        cursor: 'not-allowed'
                                    }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: '#e5e7eb',
                                    padding: '0.125rem 0.5rem',
                                    borderRadius: '0.25rem',
                                    fontSize: '0.75rem',
                                    color: '#6b7280'
                                }}>
                                    Fixed
                                </div>
                            </div>
                        </div>

                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#dcfce7',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <Building style={{ width: '1rem', height: '1rem', color: '#16a34a' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>Taluk</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <select
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 2.5rem 0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        appearance: 'none',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                    }}
                                    value={taluk}
                                    onChange={(e) => setTaluk(e.target.value)}
                                >
                                    <option value="">All Taluks</option>
                                    {Object.keys(districtData[district] || {}).map((t) => (
                                        <option key={t} value={t}>{t}</option>
                                    ))}
                                </select>
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none'
                                }}>
                                    <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#f3e8ff',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <Home style={{ width: '1rem', height: '1rem', color: '#9333ea' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>Village</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <select
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 2.5rem 0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        appearance: 'none',
                                        cursor: !villages.length ? 'not-allowed' : 'pointer',
                                        backgroundColor: !villages.length ? '#f9fafb' : 'white',
                                        color: !villages.length ? '#9ca3af' : 'inherit'
                                    }}
                                    value={village}
                                    onChange={(e) => setVillage(e.target.value)}
                                    disabled={!villages.length}
                                >
                                    <option value="">All Villages</option>
                                    {villages.map((v) => (
                                        <option key={v} value={v}>{v}</option>
                                    ))}
                                </select>
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none'
                                }}>
                                    <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        marginTop: '1.5rem',
                        paddingTop: '1.25rem',
                        borderTop: '1px solid #e5e7eb'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <div style={{
                                    width: '0.5rem',
                                    height: '0.5rem',
                                    backgroundColor: '#22c55e',
                                    borderRadius: '9999px',
                                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                                }}></div>
                                <span style={{ fontSize: '0.875rem', color: '#4b5563', fontWeight: 500 }}>Active Selection:</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.875rem', flexWrap: 'wrap' }}>
                                {taluk ? (
                                    <span style={{
                                        backgroundColor: '#dcfce7',
                                        color: '#15803d',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem',
                                        fontWeight: 500
                                    }}>
                                        📍 {taluk}
                                    </span>
                                ) : (
                                    <span style={{ color: '#9ca3af' }}>No taluk selected</span>
                                )}
                                {village ? (
                                    <span style={{
                                        backgroundColor: '#f3e8ff',
                                        color: '#7e22ce',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem',
                                        fontWeight: 500
                                    }}>
                                        🏘️ {village}
                                    </span>
                                ) : taluk ? (
                                    <span style={{ color: '#9ca3af' }}>No village selected</span>
                                ) : null}
                                {!taluk && !village && (
                                    <span style={{
                                        color: '#6b7280',
                                        backgroundColor: '#f3f4f6',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem'
                                    }}>
                                        Showing all data for {district}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="gridDashboard pt-3">
                {filteredData && <DashboardCards />}
            </div>

            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.5;
                    }
                }
            `}</style>
        </div>
    )
}

export default Section_3